/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleDefaultInit = (component) => () => {
    const $pager = $('<span data-gallery-pager>');

    $(component)
        .on('init', () => {
            $(component).append($pager);
        }).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            centerMode: true,
            dots: true,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            nextArrow: '<button class="slick-next slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            variableWidth: true,
            infinite: false,
        });
};

export default handleDefaultInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleDefaultInit.js